'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var Leaf = _ref => {
  var {
    attributes,
    children,
    leaf
  } = _ref;

  if (leaf.bold) {
    children = /*#__PURE__*/React__namespace.createElement("strong", null, children);
  }

  if (leaf.italic) {
    children = /*#__PURE__*/React__namespace.createElement("em", null, children);
  }

  if (leaf.strikeThrough) {
    children = /*#__PURE__*/React__namespace.createElement("s", null, children);
  }

  return /*#__PURE__*/React__namespace.createElement("span", attributes, children);
};
Leaf.propTypes = {
  attributes: index.any,
  leaf: index.any,
  children: index.node
};

exports.Leaf = Leaf;
exports.default = Leaf;
